export const Globals = {    
  name: 'Mytel',
  description: 'Mytel self-service application.',
  bundle: 'se.easytelecom.mytel',
  urls: {
    help: "https://mytel.se/hjalp/",
  },
  colors: {
    brand: '#00a551',
    alpha: '#89d68e',
    beta: '#ebebeb',
    gamma: '#212231',
    delta: '#222222',
    epsilon: '#f8f8f8',
    zeta: '#ffffff',
    eta: '#d7d7d7',
    theta: '#9b9b9b',
    iota: '#6dc98c',
    kappa: '#345736',
    lambda: '#ff3a30',
    mu: '#fc8b8b',
    nu: '#e5a051',
    xi: '#fbd343',
    omicron: '#606060',
    incoming: '#fc8b8b',
    outgoing: '#00a551',
  }
  
};
